import groupProductFamilies, { passengerDetailsGroupProductFamilies } from 'constants/groupProductFamilies';

export const isGroupBooking = (productFamily) => groupProductFamilies.includes(productFamily);

export const hasGroupDetailsForm = (productFamilyGroup) =>
  isGroupBooking(productFamilyGroup) && !passengerDetailsGroupProductFamilies.includes(productFamilyGroup);

export const getProductFamilyPath = (productFamilyGroup) => (hasGroupDetailsForm(productFamilyGroup) ? 'group' : 'pax');
